import '../../styles/tile-select.css'
import {useEffect, useState} from "react";
import {Select} from "antd";

export default function ProfileSelect({profiles, onChangeProfile}) {
    const [profile, setProfile] = useState(null)

    useEffect(() => {
        onChangeProfile && onChangeProfile(profile)
    }, [profile])

    useEffect(() => {
        if(profiles?.length > 0 && !profile) {
            setProfile(profiles[0])
        }
    }, [profiles]);

    return (
        <Select
            style={{width: 200}}
            size={'small'}
            suffixIcon={(<b>Profiles</b>)}
            value={profile?.target}
            onChange={(val) => {
                const _profile = profiles?.find(x => x.target === val)
                setProfile(_profile)
            }}
        >
            {profiles?.map(profile => (
                <Select.Option value={profile.target} key={profile.target}>
                    {profile.targetName}
                </Select.Option>
            ))}
        </Select>
    )
}